// TODO: refactor usage to ASSET_DIFFICULTY_LEVELS

export default {
	novice: "var(--hl-level-color-novice)",
	easy: "var(--hl-level-color-easy)",
	medium: "var(--hl-level-color-medium)",
	hard: "var(--hl-level-color-hard)",
	leet: "var(--hl-level-color-leet)",
};
